<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="client_order_is_load" parent="client_order">
    <tab
        id="info"
        :name="translate('client_order.section.order')"
        :href="url+'/info'">
      <ClientOrderInfo v-if="client_order_is_load"
        :client_order="client_order_info"
        @update="update_client_order"
      />
    </tab>

    <tab
        id="task_list"
        :name="translate('client_order.section.task_list')"
        :href="url+'/task_list'">
        <ClientOrderTaskList v-if="client_order_is_load"
           :client_order_id="client_order_info.id"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Client Order: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/client_orders_list'}">
              To Client Orders list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import ClientOrderInfo from './Tabs/Info/Index.vue'
import ClientOrderTaskList from './Tabs/TaskList/TaskList.vue'

export default {
  name: 'ClientOrder',
  components: {
    ClientOrderInfo,
    ClientOrderTaskList,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      client_order_info: null,
    }
  },

  computed: {
    url () { return '/client_order/' + this.$route.params.client_order_id },
    cur_id () { return this.$route.params.client_order_id },
    load () { return !this.client_order_info?.id },
    client_order_is_load() { return this.client_order_info !== null },
  },
  watch: {
    cur_id:{
      deep: true,
      handler(new_val, old_val){
        if(old_val && new_val !== old_val){
          this.$store.dispatch("WS_Unsubscribe",`client_order.${old_val}`)
        }
        if (new_val && new_val !== old_val){
          this.get_client_order()
          this.connection()
        }
      }
    },
  },

  activated(){
    this.get_client_order()
    this.connection()
  },

  deactivated() {
    if (this.client_order_info?.id) this.$store.dispatch("WS_Unsubscribe",`client_order.${this.client_order_info.id}`)
  },

  methods: {
    connection(){
      if(this.$store.getters.WsGetStatus && this.cur_id){
        this.$store.dispatch("WS_Subscribe",{ topic: `client_order.${this.cur_id}`, func: this.ParseUpdateFromServiceBridge })
      }
    },
    ParseUpdateFromServiceBridge(cmd){
      if(cmd.data?.action === 'UPDATE'){
        if (this.cur_id) this.get_client_order()
      }
    },
    update_client_order(data){
      this.client_order_info = data
    },
    get_client_order () {
      this.$http.v1.getClientOrderInfo(this.$route.params.client_order_id, (response) => {
        this.client_order_info = response.data
        this.$store.commit('updateSelectedClientOrder', response.data)
      })
    }
  }
}

</script>
